import React, {  useState, forwardRef } from 'react';
import { List, ListItem, Collapse, Button, SwipeableDrawer, Typography, Box } from '@material-ui/core';
import { NavLink as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import menuItems from './sideBarItems';
import useStyles from './sideBarStyles';


const SideBar = (props) => {
  const [menu, setMenu] = useState({});
  const { className, ...rest } = props;
  const classes  = useStyles();
  const { t } = useTranslation();

  const handleClick = (item) => {
    let newData = {...menu, [item] : !menu[item]};
    setMenu(newData);
  };

  const CustomRouterLink = forwardRef((props, ref) => (
    <div ref={ref} style={{ flexGrow: 1 }}>
      <RouterLink {...props} />
    </div>
  ));

  const handleMenu = ( children, level=0 ) => {
    return children.map(({subChildren, name, url }) => {
      if (!subChildren) {
        return (
          <List component="div" disablePadding key={name}>
            <ListItem
              className={classes.item}
              disableGutters
              key={name}>
              <Button
                className={clsx({
                  [classes.btnRoot] : true,
                  [classes.button] : true,
                  [classes.subMenu] : level })}
                component={CustomRouterLink}
                to={url}>
                {name}
              </Button>
            </ListItem>
          </List>
        );
      }

      return (
        <div key={name}>
          <ListItem
            className={classes.item}
            disableGutters
            key={name}
            onClick={() => handleClick(name)}>
          </ListItem>
          <Collapse
            in={ (menu[name]) ? true : false }
            timeout="auto"
            unmountOnExit>
            {handleMenu(subChildren, 1)}
          </Collapse>
        </div>
      );
    });
  };

  const translateItems = (menuItems) => {
    return menuItems.data.map(item => ({
      'name': t(item.name),
      'url': item.url
    }));
  };

  const translatedItems = translateItems(menuItems);

  return (
    <>
      <SwipeableDrawer
        className={classes.drawer}
        variant="permanent"
        classes={{ paper: classes.drawerPaper }}
        elevation={16}
        open={true}
        onOpen={() => {}}
        onClose={() => {}}
        anchor="left" >
        <Box display="flex" flexDirection="column" flexGrow="1">
          <Typography
            align={'center'}
            color={'primary'}
            component="div"
            style={{
              padding: '0px',
              borderBottom: '1px solid lightGrey'
            }}>
            <Box
              fontSize={24}
              fontWeight="fontWeightBold" m={1}>
              {t('marketing-tool')}
            </Box>
          </Typography>
          <List {...rest} className={clsx(classes.root, className)} >
            {handleMenu(translatedItems)}
          </List>
          <Box display="flex" alignItems="flex-end" flexGrow="1">
            <Button component="div" href="https://ykl-doris-dev-func-adminapi.azurewebsites.net" className={classes.footer}>
              {t('doris')}
            </Button>
          </Box>
        </Box>
      </SwipeableDrawer>
    </>
  );
};


export default SideBar;
